export const DEFAULT_ICON_PACK = 'MaterialCommunityIcons';
export const STYLE_WRAPPER_TYPE = {
  fixedSize: 'fixedSize',
  relativeSize: 'relativeSize'
};
export const MODE_TYPE = {
  filled: 'filled',
  outlined: 'outlined',
  ghost: 'ghost'
};
export const COLOR_TYPE = {
  primary: 'primary',
  secondary: 'secondary',
  error: 'error',
  warning: 'warning',
  info: 'info',
  success: 'success'
};
export const INVERT_COLOR_TYPE = {
  primary: 'basic',
  secondary: 'primary',
  error: 'info',
  warning: 'basic',
  info: 'basic',
  success: 'basic'
};
export const Constants = {
  SHORT_TIMEOUT: 340,
  LONG_TIMEOUT: 700
};